import { add, isBefore } from "date-fns";
import { AccountHolderData, TenantSettingsData } from "osn-participantapi-client";

export function needToSignCoachAgreement(data: AccountHolderData, tenantConfigs: TenantSettingsData) {
  if (!data) {
    return true;
  }

  return (
    !data?.lastAcceptedVolunteerAgreement ||
    isBefore(
      add(data.lastAcceptedVolunteerAgreement, { days: tenantConfigs.volunteerAgreementValidityDays || 365 }),
      new Date(),
    )
  );
}

export function needToSignAgreement(data: AccountHolderData, tenantConfigs: TenantSettingsData) {
  if (!data) {
    return true;
  }

  return (
    !data?.lastAcceptedGeneralAgreement ||
    isBefore(
      add(data.lastAcceptedGeneralAgreement, { days: tenantConfigs.participantAgreementValidityDays || 365 }),
      new Date(),
    )
  );
}
